











































































































import { mapState } from "vuex";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSorted from "@/common/components/icons/IconSorted.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import InputDate from "@/common/components/atoms/InputDate.vue";

import modalState from "@/common/store/modules/modalState";

@Component({
  components: {
    ButtonRefineBase,
    IconBase,
    IconSorted,
    IconArrowBottom,
    ModalMain,
    ButtonMain,
    InputDate
  },

  computed: {
    ...mapState({
      modalName: state => modalState.modalName
    })
  }
})
export default class ButtonRefine extends Vue {
  @Prop({ type: [String, Boolean], default: "絞り込み" }) heading!: string;
  @Prop({ type: [String, Boolean], default: false }) icon!: string;
  @Prop({ type: String, default: "#000000" }) iconColor!: string;
  @Prop({ type: [Array, Boolean], default: false, required: true })
  refineItemList!: boolean;
  @Prop({ type: [String, Number], default: "" }) refine!: string;
  @Prop({ type: Boolean, default: false }) rangeEnable!: boolean;
  @Prop({ type: Boolean, default: false }) shown!: boolean;
  @Prop({ type: String, default: "130px", required: false }) width!: string;

  switchState = this.shown;
  listStyle: object = {};

  sortedHeading: any = "";
  sortModal = false;
  sortedDates: any = "";
  sortBetweenMinDate: any = "";
  sortBetweenMaxDate: any = "";

  get sortBeteenMinDate() {
    return new Date(1900, 11, 1);
  }

  get sortBeteenMaxDate() {
    return new Date();
  }

  inputDate(inputDate: any) {
    if (inputDate.name == "sortBetweenMinDate") {
      this.sortBetweenMinDate = inputDate.value;
      this.sortBetweenMinDate = this.$dayjs(this.sortBetweenMinDate).format(
        "YYYY-MM-DD"
      );
    } else {
      this.sortBetweenMaxDate = inputDate.value;
      this.sortBetweenMaxDate = this.$dayjs(this.sortBetweenMaxDate).format(
        "YYYY-MM-DD"
      );
    }
  }

  get internalRefine(): any {
    return this.refine;
  }

  set internalRefine(newValue: any) {
    this.sortedHeading = newValue;
    if (this.refine !== newValue) {
      if (newValue != "specify_period") {
        if (newValue == "all") {
          this.sortedHeading = "すべての期間";
        }
        this.$emit("update:refine", newValue);
        this.$emit("do-sort", newValue);
        this.switchShownState();
      } else if (newValue == "specify_period") {
        if (this.rangeEnable) {
          modalState.changeModal("dateSortModal");
          sessionStorage.removeItem("whatsNewMonth");
          sessionStorage.removeItem("whatsNewYear");
        }
        this.sortedHeading = "期間指定";
      }
      sessionStorage.sortedHeading = this.sortedHeading;
    }
  }

  setSortDate(date: any) {
    if (date != "all" && date != "specify_period") {
      this.$emit("do-sort", date);
      date = date.split(".");
      this.sortedHeading = date[0] + "年" + date[1];
    } else if (date == "all") {
      this.$emit("do-sort", date);
      this.sortedHeading = "すべての期間";
    } else {
      this.sortedHeading = "期間指定";
      modalState.changeModal("dateSortModal");
      sessionStorage.removeItem("whatsNewMonth");
      sessionStorage.removeItem("whatsNewYear");
    }

    sessionStorage.sortedHeading = this.sortedHeading;
  }

  betweenSort() {
    if (this.sortBetweenMinDate != "" && this.sortBetweenMaxDate != "") {
      const betweenSortDates = {
        startDate: this.sortBetweenMinDate,
        endDate: this.sortBetweenMaxDate
      };
      this.sortedHeading =
        "期間指定(" +
        this.sortBetweenMinDate.replaceAll("-", "/") +
        "--" +
        this.sortBetweenMaxDate.replaceAll("-", "/") +
        ")";
      sessionStorage.sortedHeading = this.sortedHeading;
      this.$emit("betweenSort", betweenSortDates);
    }

    this.closeModal();
  }

  @Watch("sortedHeading")
  onPropertyChanged(newVal: string, oldValue: string) {
    this.sortedHeading = newVal;
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  @Watch("closeModalState")
  onCloseModalState() {
    this.switchState = false;
    this.$emit("switch-refine-state", false);
  }

  mounted() {
    this.initSelectContentListStyle();
  }

  switchShownState() {
    const shownState = this.shown;
    const changeState = !shownState;
    this.$emit("switch-refine-state", changeState);
  }

  initSelectContentListStyle() {
    const button = this.$refs;
    const buttonHeight: any = button.clientHeight;
    this.listStyle = {
      top: `${buttonHeight / 16}rem`,
      width: `${this.width}`
    };
  }

  closeModal() {
    modalState.changeModal("");
    const switchState = !this.shown;
    this.$emit("switch-refine-state", switchState);
  }

  get iconComponent() {
    if (!this.icon) {
      return "IconSorted";
    }

    switch (this.icon) {
      case "sorted":
        return "IconSorted";
      case "arrow":
        return "IconArrowBottom";
      default:
        return "IconSorted";
    }
  }

  async created() {
    this.switchState = this.shown;
    if (this.rangeEnable) {
      if (sessionStorage.sortedHeading) {
        this.sortedHeading = sessionStorage.sortedHeading;
      } else {
        this.sortedHeading = this.heading;
      }
    }
  }
}
